













import Vue, { PropType } from 'vue'
import { DirectMessage } from '../../../base/store/state.interface'
import MessagesWidgetMixins from '../messages-widget/MessagesWidgetMixins'

export default Vue.extend({
  mixins: [MessagesWidgetMixins],
  props: {
    message: {
      required: true,
      type: Object as PropType<DirectMessage>
    },
    index: {
      type: String as PropType<string>,
      required: true,
      default: ''
    }
  },
  computed: {
    componentCssClasses() {
      return [
        'widget--direct-messages--item',
        'box',
        {
          'unread': this.message.new
        }
      ]
    }
  }
})
